import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { LabelOption } from '@/api/api';

export const FOLDER_LABEL_OPTIONS_QUERY_KEY = 'folders.labelOptions';

export const useGetFolderLabelOptions = ({ folderId, enabled = true }: { folderId?: string; enabled?: boolean }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [FOLDER_LABEL_OPTIONS_QUERY_KEY, { folderId, tenantId }],
    queryFn: () => {
      return folderId
        ? api.tenants.getFolderLabelOptions(tenantId, folderId)
        : api.tenants.getRootLabelOptions(tenantId);
    },
    enabled: enabled && !!tenantId,
  });

  return {
    labelOptions: (data?.data?.labels ?? []) as LabelOption[],
    isLoading,
    error,
  };
};
